export default __webpack_public_path__ + "assets/83023953599de4b3531d40a65039178b.svg";